import React, { useState, useEffect } from "react";
import "../styles/Landingpage.css";
import Logo from "../Assets/imgs/logo.webp";
import { Spinner } from "react-bootstrap";
import mainimage from "../Assets/imgs/landingpage.webp";

type Props = {
  msisdn: any;
  inputRef: React.RefObject<HTMLInputElement>[];
  otp: {
    one: string;
    two: string;
    three: string;
    four: string;
  };
  handleOtpInput: (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => void;
  handleBackspace: (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => void;
  handleOtpSubmit: () => void;
  error: string;
  loader: boolean;
  showErro: boolean;
  handleSignupWeb: () => Promise<void>;
};

const OtpPage = (props: Props) => {
  const [showResendButton, setShowResendButton] = useState(false);
  const [timer, setTimer] = useState(30); // Set initial timer value

  useEffect(() => {
    let countdown: NodeJS.Timeout;
    if (!showResendButton) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer === 0) {
            setShowResendButton(true);
            clearInterval(countdown); // Stop the countdown
            return prevTimer;
          }
          return prevTimer - 1;
        });
      }, 1000); // Decrease timer every second
    }

    return () => {
      if (countdown) {
        clearInterval(countdown); // Clear the countdown interval on unmount
      }
    };
  }, [showResendButton]);

  const handleResendClick = () => {
    props.handleSignupWeb();
    setTimer(30); // Reset the timer value
    setShowResendButton(false); // Hide the resend button
  };

  return (
    <div className="landing-bg">
      <div className="subscrption-page">
        <div className="subscrption-logo">
          <img src={Logo} alt="logo image" width={125} height={40} />
        </div>
      </div>

      <div className="subscrption-content ">
        <div className="subscrption-inner">
          <div className="image">
            <img src={mainimage} width={355} height={355} alt="image" />
          </div>
          <div className="form">
            <div className="input-content">
              <div className="text otp">
               Enter OTP
              </div>

              <div className="otp-inputs">
                <input
                  type="tel"
                  name="one"
                  maxLength={1}
                  ref={props.inputRef[0]}
                  value={props.otp.one}
                  onChange={(e) => props.handleOtpInput(e, 0)}
                  onKeyDown={(e) => props.handleBackspace(e, 0)}
                  autoFocus
                />
                <input
                  type="tel"
                  name="two"
                  maxLength={1}
                  ref={props.inputRef[1]}
                  value={props.otp.two}
                  onChange={(e) => props.handleOtpInput(e, 1)}
                  onKeyDown={(e) => props.handleBackspace(e, 1)}
                // autoFocus
                />
                <input
                  type="tel"
                  name="three"
                  maxLength={1}
                  ref={props.inputRef[2]}
                  value={props.otp.three}
                  onChange={(e) => props.handleOtpInput(e, 2)}
                  onKeyDown={(e) => props.handleBackspace(e, 2)}
                // autoFocus
                />
                <input
                  type="tel"
                  name="four"
                  maxLength={1}
                  ref={props.inputRef[3]}
                  value={props.otp.four}
                  onChange={(e) => props.handleOtpInput(e, 3)}
                  onKeyDown={(e) => props.handleBackspace(e, 3)}
                // autoFocus
                />
              </div>
            </div>

            <div className="resend-code">
              {showResendButton ? (
                  <div className="timer-text">Didn't you receive the OTP? <span onClick={handleResendClick}>Resend</span>
                </div>
              ) : (
                <div className="not-received">
                  00:{timer < 10 ? `0${timer}` : timer}
                </div>
              )}
            </div>
            {props.showErro ? (
              <>
                <p className="error" style={{textAlign: "center"}}>{props.error}</p>
              </>
            ) : (
              <></>
            )}
            {props.loader ? (
              <>
                <div className="SpinnerBtn">
                  <button>
                    <Spinner
                      animation="border"
                      className="SpinnerBtn"
                      role="status"
                      style={{ color: "#5424FD" }}
                    >
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </button>
                </div>
              </>
            ) : (
              <>
                <button
                  onClick={() => {
                    props.handleOtpSubmit();
                  }}
                >
                  Submit
                </button>
              </>
            )}

            {/* <div className="resend-code">
              {showResendButton ? (
                <span onClick={handleResendClick}>Resend Code</span>
              ) : (
                <div className="not-received">
                  <span className="timer-text">Didn’t Receive OTP?</span> 00:
                  {timer < 10 ? `0${timer}` : timer}
                </div>
              )}
            </div> */}

            {/*  */}

            <div className="prepaid-text">Prepaid Charges : Rs 5+T/Day*</div>

            <div className="condition">
              <a href="/privacy-policy" target="_blank">
                Privacy Policy
              </a>

              <span></span>

              <a href="/terms" target="_blank">
                Terms & Conditions{" "}
              </a>
            </div>
            {/*  */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtpPage;
